
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import Platforms from "@/dtos/socialMediaPlattform";
import PlatformChart from "@/views/Marketing/PlatformChart.vue";
import moment from "moment";
import DatePicker from "@/components/DatePicker.vue";

@Component({
	components: {
		PlatformChart,
		DatePicker,
	},
})
export default class MarketingStatistics extends Vue {
	private active: any = null;
	private loading: boolean = false;
	private statistics: any = [];
	private platforms: any = Platforms;
	private valueToShow: string = "Klicks";
	private valuesToShow: string[] = ["Klicks", "Registrierungen"];
	private startDate: string = moment().subtract(1, "month").format("YYYY-MM-01");
	private endDate: string = moment().format("YYYY-MM-DD");
	private reloadToggle: boolean = false;

	private mounted() {
		this.loadStatistics();
	}

	private async reloadDate() {
		await this.loadStatistics();
		this.reloadToggle = !this.reloadToggle;
	}

	private get platformGroups() {
		if (!this.statistics || !this.statistics.platformStatistics) return [];
		const relevantPlatforms = this.platforms.map((p: any) => p.value);
		const filtered = this.statistics.platformStatistics.filter((s: any) =>
			relevantPlatforms.includes(s.platform)
		);
		const grouped = filtered.reduce((acc: any, item: any) => {
			if (!acc[item.platform]) acc[item.platform] = [];
			acc[item.platform].push(item);
			return acc;
		}, {});
		return grouped;
	}

	private async loadStatistics() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Marketing/GetMarketingStatistics?from=${this.startDate}&to=${this.endDate}`
			);
			this.statistics = response.data;
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Statistik konnte nicht geladen werden.");
		} finally {
			this.loading = false;
		}
	}

	private getCampaignOverviews(campaigns: any[]) {
		let overviews = [];
		for (const campaign of campaigns) {
			overviews.push({
				name: campaign.campaignDescription,
				createdAt: moment(campaign.campaignCreatedAt).format("DD.MM.YYYY"),
				totalClicks: campaign.dailyActivities.reduce((total: number, current: any) => {
					return total + current.clicks;
				}, 0),
				totalRegistrations: campaign.dailyActivities.reduce(
					(total: number, current: any) => {
						return total + current.registrations;
					},
					0
				),
				registeredUsers: campaign.registeredUsers,
			});
		}
		if (this.valueToShow == "Klicks") {
			overviews = overviews.sort((a: any, b: any) => b.totalClicks - a.totalClicks);
		} else {
			overviews = overviews.sort(
				(a: any, b: any) => b.totalRegistrations - a.totalRegistrations
			);
		}
		return overviews;
	}

	private getOrderAmount(users: any[], regionId: number): string {
		if (!users || users.length <= 0) return "";
		const filteredUsers = this.statistics.orderAmounts.filter(
			(a: any) =>
				Object.keys(users).includes(a.userId) && (regionId === 0 || a.regionId === regionId)
		);
		return filteredUsers
			.reduce((sum: any, current: any) => sum + current.orderAmount, 0)
			.toFixed(2);
	}

	private getUserCount(users: any[], regionId: number): string {
		if (!users || users.length <= 0) return "";
		const filteredUsers = this.statistics.orderAmounts.filter(
			(a: any) =>
				Object.keys(users).includes(a.userId) && (regionId === 0 || a.regionId === regionId)
		);
		return filteredUsers.length;
	}

	private getOrderAmountOfUser(userId: string): number {
		const user = this.statistics.orderAmounts.filter((a: any) => a.userId === userId)[0];
		if (user) {
			return user.orderAmount;
		} else {
			return 0;
		}
	}

	private sortedUsersWithOrderAmounts(users: any) {
		let userList = [];
		for (const [userId, email] of Object.entries(users)) {
			userList.push({
				id: userId,
				email: email,
				amount: this.getOrderAmountOfUser(userId),
			});
		}
		return userList.sort((u1: any, u2: any) => u2.amount - u1.amount);
	}

	private goToAdCampaigns() {
		this.$router.push({ name: "adCampaigns" });
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD");
	}
}
